import { chatApi } from './apiManager';

interface StartChatResponse {
  sessionId: string;
  firstMessage: string;
}

interface ContinueChatRequest {
  sessionId: string;
  userMessage: string;
  categoryPrompt: string;
}

interface ContinueChatResponse {
  message: string;
  continue: boolean;
}

class ChatService {
  async startChat(userId: string | number, categoryPrompt: string): Promise<StartChatResponse> {
    try {
      
      const response = await chatApi.startChat(userId, categoryPrompt);
      
      
      if (!response.success) {
        const errorMessage = response.error || 'Failed to start chat';
        console.error('ChatService: API call failed:', {
          error: errorMessage
        });
        throw new Error(errorMessage);
      }

      return response.data;
    } catch (error) {
      console.error('ChatService: Start chat failed:', {
        error: error instanceof Error ? error.message : 'Unknown error',
      });
      throw error;
    }
  }

  async continueChat(request: ContinueChatRequest): Promise<ContinueChatResponse> {
    try {
      const response = await chatApi.continueChat(
        request.sessionId, 
        request.userMessage, 
        request.categoryPrompt
      );
      
      if (!response.success) {
        throw new Error(response.error || 'Failed to continue chat');
      }

      return response.data;
    } catch (error) {
      console.error('Continue chat failed:', error instanceof Error ? error.message : 'Unknown error');
      throw error;
    }
  }
}

export const chatService = new ChatService();
export type { StartChatResponse, ContinueChatRequest, ContinueChatResponse }; 